export default "__VITE_ASSET__QB$olTPc__"